import React from 'react'
import { Outlet } from 'react-router-dom'

export default function Services() {

  return (
    <div>
        <section>
            <Outlet/>
        </section>
    </div>
  )
}
